export default __webpack_public_path__ + "ef75ed8ddf27954f5623126ae898ce97.png";